import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { Y42AssetStatus } from '@y42/json-schema';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssetStatusToUI } from '../../../models';

@UntilDestroy()
@Component({
  selector: 'y42-asset-status-cell-renderer',
  templateUrl: './asset-status-cell-renderer.component.html',
  styleUrls: ['./asset-status-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetStatusCellRendererComponent implements ICellRendererAngularComp {
  private readonly params$$ = new BehaviorSubject<ICellRendererParams<unknown, Y42AssetStatus> | null>(null);

  private readonly statusEnum$: Observable<Y42AssetStatus | null> = this.params$$.pipe(
    map((params) => (params?.value && params.value !== Y42AssetStatus.NoStatus ? params.value : null)),
  );
  readonly state = connectState(this, {
    text: this.statusEnum$.pipe(map((statusEnum) => (statusEnum ? AssetStatusToUI[statusEnum].label : '-'))),
    logo: this.statusEnum$.pipe(map((statusEnum) => (statusEnum ? AssetStatusToUI[statusEnum].logo : null))),
    color: this.statusEnum$.pipe(map((statusEnum) => AssetStatusToUI[statusEnum ?? Y42AssetStatus.NoStatus].color)),
  });

  agInit(params: ICellRendererParams<unknown, Y42AssetStatus>): void {
    this.params$$.next(params);
  }

  refresh(): boolean {
    return false;
  }
}
